var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var loaderCircle = React.createElement("div", { className: "rj-loader-circle" });
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        return (React.createElement("div", { className: "rj-loader" },
            React.createElement("div", { className: "rj-loader-spinner rj-loader-container" },
                React.createElement("div", { className: "rj-loader-spinner rj-loader-fill" },
                    React.createElement("div", { className: "rj-loader-clipper left" }, loaderCircle),
                    React.createElement("div", { className: "rj-loader-gap-patch" }, loaderCircle),
                    React.createElement("div", { className: "rj-loader-clipper right" }, loaderCircle)))));
    };
    return Loader;
}(React.PureComponent));
export { Loader };
//# sourceMappingURL=Loader.js.map